
// A/B test H1 — apply variant ASAP (post-DOM-ready) to show only chosen version (no FOUC)
(function(){
  var v=window._hlH1Variant||'A';
  function apply(){
    var nodes=document.querySelectorAll('.h1-variant');
    nodes.forEach(function(n){
      if(n.getAttribute('data-h1')===v){n.classList.add('h1-show');n.removeAttribute('hidden');}
      else{n.classList.remove('h1-show');n.setAttribute('hidden','');}
    });
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',apply);}else{apply();}
})();


// ═══════════════════════════════════════════════════════════════


// Shared state for spray discount — usato da bundle IIFE + popup IIFE
window.hlSprayDiscount = {
  KEY: 'hl_spray_discount_unlocked_v1',
  TS_KEY: 'hl_spray_discount_ts_v1',
  CODE: 'GRAZIA20',
  PERCENT: 0.20,
  DURATION_MS: 10 * 60 * 1000,
  isActive: function(){
    try {
      if (localStorage.getItem(this.KEY) !== '1') return false;
      var ts = parseInt(localStorage.getItem(this.TS_KEY) || '0', 10);
      return ts > 0 && (Date.now() - ts) < this.DURATION_MS;
    } catch(e) { return false; }
  },
  unlockTs: function(){
    try { return parseInt(localStorage.getItem(this.TS_KEY) || '0', 10); } catch(e) { return 0; }
  }
};

// Bundle selection
(function(){
  var bundles = document.querySelectorAll('.bun');
  var stickyName = document.getElementById('sticky-name');
  var stickyPrice = document.getElementById('sticky-price');
  var stickyPriceOld = document.getElementById('sticky-price-old');
  var stickyBtn = document.getElementById('sticky-btn');

  function fmtPrice(n){
    return '€' + (Number.isInteger(n) ? n : n.toFixed(2).replace('.',','));
  }

  function updateSticky(b){
    var name = b.getAttribute('data-name');
    var basePrice = parseFloat(b.getAttribute('data-price'));
    var duration = b.getAttribute('data-duration') || '';
    var discountActive = window.hlSprayDiscount && window.hlSprayDiscount.isActive();
    var displayPrice = discountActive ? Math.round(basePrice * (1 - window.hlSprayDiscount.PERCENT) * 100) / 100 : basePrice;

    if (stickyName) stickyName.textContent = name + (duration ? ' · ' + duration : '');
    if (stickyPrice) stickyPrice.textContent = fmtPrice(displayPrice);
    if (stickyPriceOld) {
      if (discountActive) {
        stickyPriceOld.textContent = '€' + basePrice + ' ';
        stickyPriceOld.hidden = false;
      } else {
        stickyPriceOld.textContent = '';
        stickyPriceOld.hidden = true;
      }
    }
    // Btn: ora è anchor a #bundles (no più checkout link diretto)
    // Manteniamo solo il tracking event al click
  }

  // Track click sul sticky CTA (anche se è solo anchor scroll, è un intent signal)
  if (stickyBtn) {
    stickyBtn.addEventListener('click', function(){
      var sel = document.querySelector('.bun.sel');
      var bundleName = sel ? sel.getAttribute('data-name') : 'unknown';
      var bundleValue = sel ? parseFloat(sel.getAttribute('data-price')) : 0;
      if (window.gtag) gtag('event', 'sticky_btn_clicked', {
        bundle: bundleName,
        value: bundleValue,
        discount_active: window.hlSprayDiscount && window.hlSprayDiscount.isActive(),
        page_type: 'spray_offerta'
      });
      if (window.fbq) fbq('trackCustom', 'StickyScrollClicked', { bundle: bundleName, page: 'spray_offerta' });
    });
  }

  // Esponi al popup IIFE per chiamarlo quando lo sconto cambia stato
  window.hlUpdateSelectedSticky = function(){
    var sel = document.querySelector('.bun.sel');
    if (sel) updateSticky(sel);
  };

  // Tier-reward bar update (Dylan Ch 9 — Free Gift Tiers visual)
  function updateTierReward(price){
    var fill = document.getElementById('tr-fill');
    if(!fill) return;
    var steps = document.querySelectorAll('.tier-reward-step');
    var rows = document.querySelectorAll('.tier-reward-row');
    // Step active index: 1=Provalo, 2=Protocollo, 3=Mantenimento
    var stepIdx = price >= 73 ? 3 : (price >= 49 ? 2 : 1);
    var pct = stepIdx === 1 ? 16 : (stepIdx === 2 ? 50 : 100);
    fill.style.width = pct + '%';
    steps.forEach(function(s){
      var n = parseInt(s.getAttribute('data-tr-step'), 10);
      s.classList.remove('tr-active','tr-reached');
      if(n < stepIdx) s.classList.add('tr-reached');
      else if(n === stepIdx) s.classList.add('tr-active');
    });
    rows.forEach(function(r){
      var n = parseInt(r.getAttribute('data-tr-tier'), 10);
      r.classList.toggle('tr-unlocked', n <= stepIdx);
      var icon = r.querySelector('.tier-reward-row-icon');
      if(icon) icon.textContent = (n <= stepIdx) ? '✓' : '+';
    });
  }

  function select(b){
    bundles.forEach(function(x){ x.classList.remove('sel'); });
    b.classList.add('sel');
    updateSticky(b);
    updateTierReward(parseFloat(b.getAttribute('data-price')) || 0);
    if(window.gtag){
      gtag('event','bundle_select',{
        bundle: b.getAttribute('data-name'),
        value: parseInt(b.getAttribute('data-price'),10),
        page_type: 'spray_offerta'
      });
    }
  }

  bundles.forEach(function(b){
    b.addEventListener('click', function(e){
      if(e.target.closest('a')) return;
      select(b);
    });
  });

  var sel = document.querySelector('.bun.sel');
  if(sel){
    updateSticky(sel);
    updateTierReward(parseFloat(sel.getAttribute('data-price')) || 49);
  }
})();

// FAQ accordion
(function(){
  var items = document.querySelectorAll('.faq-item');
  items.forEach(function(item){
    var q = item.querySelector('.faq-q');
    if(!q) return;
    q.addEventListener('click', function(){
      var open = item.classList.contains('open');
      if(open){ item.classList.remove('open'); q.setAttribute('aria-expanded','false'); }
      else { item.classList.add('open'); q.setAttribute('aria-expanded','true'); }
      if(window.gtag) gtag('event','faq_toggle',{q: q.textContent.slice(0,60), page_type:'spray_offerta'});
    });
  });
})();

// Hide sticky once user reaches the final CTA
(function(){
  var sticky = document.getElementById('sticky');
  var finalCta = document.querySelector('.final');
  if(!sticky || !finalCta || !('IntersectionObserver' in window)) return;
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      sticky.style.transform = e.isIntersecting ? 'translateY(110%)' : 'translateY(0)';
      sticky.style.transition = 'transform .25s ease';
    });
  }, { threshold: 0.3 });
  io.observe(finalCta);
})();

// Section visibility — track quale sezione l'utente raggiunge davvero (drop-off analysis)
(function(){
  if(!('IntersectionObserver' in window) || !window.gtag) return;
  var sections = [
    {sel: '.story', name: 'story_chiara'},
    {sel: '.conf', name: 'confession_grazia'},
    {sel: '.tri', name: 'triangolo'},
    {sel: '.discr', name: 'why_failed'},
    {sel: '.sol', name: 'solution_tc3'},
    {sel: '.tline', name: 'timeline_chiara'},
    {sel: '#bundles', name: 'bundles'},
    {sel: '.urg', name: 'urgency'},
    {sel: '.testi', name: 'testimonials'},
    {sel: '.faq', name: 'faq'},
    {sel: '.final', name: 'final_cta'}
  ];
  var fired = {};
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if(!e.isIntersecting) return;
      var name = e.target.getAttribute('data-section');
      if(!name || fired[name]) return;
      fired[name] = true;
      gtag('event','section_view',{section: name, page_type: 'spray_offerta'});
      if(window.fbq) fbq('trackCustom','SectionView',{section: name, page: 'spray_offerta'});
    });
  }, { threshold: 0.4 });
  sections.forEach(function(s){
    var el = document.querySelector(s.sel);
    if(el){ el.setAttribute('data-section', s.name); io.observe(el); }
  });
})();

// Video play tracking (routine 3-step) — fire una volta sola
(function(){
  var video = document.querySelector('.steps-vid video');
  if(!video || !window.gtag) return;
  var fired = {play:false, p25:false, p50:false, p100:false};
  video.addEventListener('play', function(){
    if(fired.play) return; fired.play = true;
    gtag('event','video_play',{video:'routine_3step', page_type:'spray_offerta'});
  });
  video.addEventListener('timeupdate', function(){
    if(!video.duration) return;
    var pct = video.currentTime / video.duration;
    if(pct>=0.25 && !fired.p25){fired.p25=true;gtag('event','video_progress',{video:'routine_3step',pct:25,page_type:'spray_offerta'});}
    if(pct>=0.50 && !fired.p50){fired.p50=true;gtag('event','video_progress',{video:'routine_3step',pct:50,page_type:'spray_offerta'});}
    if(pct>=0.95 && !fired.p100){fired.p100=true;gtag('event','video_progress',{video:'routine_3step',pct:100,page_type:'spray_offerta'});}
  });
})();

// ════════════════════════════════════════════════════════════════
// CTA click tracking (per simulare RPC/RPS per element in GA4, vista
// che non abbiamo Heatmap.com). Ogni CTA marcato con data-cta-id +
// data-cta-pos spara cta_click su gtag e fbq trackCustom. Successive
// query in GA4: cta_click conv_rate → Purchase per cta_id = RPC approx.
// ════════════════════════════════════════════════════════════════
(function(){
  if(!('addEventListener' in document)) return;
  document.addEventListener('click', function(e){
    var el = e.target.closest('[data-cta-id]');
    if(!el) return;
    var ctaId = el.getAttribute('data-cta-id');
    var ctaPos = el.getAttribute('data-cta-pos') || 'unknown';
    var hasDiscount = window.hlSprayDiscount && window.hlSprayDiscount.isActive();
    if(window.gtag){
      gtag('event','cta_click',{
        cta_id: ctaId,
        cta_pos: ctaPos,
        discount_active: !!hasDiscount,
        page_type:'spray_offerta'
      });
    }
    if(window.fbq){
      fbq('trackCustom','CTAClick',{cta_id: ctaId, cta_pos: ctaPos, page:'spray_offerta'});
    }
  }, {passive:true, capture:true});
})();

// ════════════════════════════════════════════════════════════════
// Outbound link tracking (Conversion Killers audit — Dylan Ander Ch5).
// Cattura click su mailto / wa.me / link a hairletics.com fuori dal cart
// per quantificare RPS dei "distractor link" che portano via dal funnel.
// ════════════════════════════════════════════════════════════════
(function(){
  if(!('addEventListener' in document)) return;
  document.addEventListener('click', function(e){
    var a = e.target.closest('a[href]');
    if(!a) return;
    var href = a.getAttribute('href') || '';
    if(href.indexOf('hairletics.com/cart/') !== -1) return; // questi sono CTA buy, già tracciati
    if(href.indexOf('#') === 0) return; // anchor interno
    var kind = '';
    if(href.indexOf('mailto:') === 0) kind = 'mailto';
    else if(href.indexOf('wa.me') !== -1 || href.indexOf('whatsapp') !== -1) kind = 'whatsapp';
    else if(href.indexOf('hairletics.com/policies') !== -1) kind = 'policy';
    else if(href.indexOf('salute.hairletics.com/protocollo') !== -1) kind = 'protocollo_alt';
    else if(/^https?:\/\//i.test(href)) kind = 'outbound_other';
    if(!kind) return;
    if(window.gtag){
      gtag('event','outbound_click',{
        outbound_kind: kind,
        outbound_url: href.slice(0,200),
        page_type:'spray_offerta'
      });
    }
    if(window.fbq){
      fbq('trackCustom','OutboundClick',{kind: kind, page:'spray_offerta'});
    }
  }, {passive:true, capture:true});
})();

// ════════════════════════════════════════════════════════════════
// Product gallery (Heatmap CRO #9-17) — main + thumbs + arrows + swipe + dots
// ════════════════════════════════════════════════════════════════
(function(){
  var gal = document.getElementById('pgal');
  if (!gal) return;
  var slides = gal.querySelectorAll('.pgal-slide');
  var thumbs = gal.querySelectorAll('.pgal-thumb');
  var dots = gal.querySelectorAll('.pgal-dot');
  var prevBtn = document.getElementById('pgal-prev');
  var nextBtn = document.getElementById('pgal-next');
  var main = document.getElementById('pgal-main');
  if (!slides.length) return;
  var current = 0;
  var total = slides.length;
  function setSlide(idx){
    if (idx < 0) idx = total - 1;
    if (idx >= total) idx = 0;
    current = idx;
    slides.forEach(function(s, i){ s.classList.toggle('active', i === idx); });
    thumbs.forEach(function(t, i){ t.classList.toggle('active', i === idx); });
    dots.forEach(function(d, i){ d.classList.toggle('active', i === idx); });
    if (window.gtag) gtag('event', 'gallery_slide_view', { slide_idx: idx, page_type: 'spray_offerta' });
  }
  // Arrow click
  if (prevBtn) prevBtn.addEventListener('click', function(){ setSlide(current - 1); });
  if (nextBtn) nextBtn.addEventListener('click', function(){ setSlide(current + 1); });
  // Thumb click
  thumbs.forEach(function(t){
    t.addEventListener('click', function(){
      var idx = parseInt(t.getAttribute('data-pgt'), 10) || 0;
      setSlide(idx);
    });
  });
  // Dot click
  dots.forEach(function(d){
    d.addEventListener('click', function(){
      var idx = parseInt(d.getAttribute('data-pgd'), 10) || 0;
      setSlide(idx);
    });
  });
  // Swipe touch (mobile)
  var touchStartX = 0, touchEndX = 0, touchStartY = 0, touchEndY = 0;
  if (main) {
    main.addEventListener('touchstart', function(e){
      var t = e.changedTouches[0];
      touchStartX = t.screenX; touchStartY = t.screenY;
    }, { passive: true });
    main.addEventListener('touchend', function(e){
      var t = e.changedTouches[0];
      touchEndX = t.screenX; touchEndY = t.screenY;
      var dx = touchEndX - touchStartX;
      var dy = touchEndY - touchStartY;
      // Solo swipe orizzontale (evita conflict con scroll verticale)
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
        if (dx < 0) setSlide(current + 1); // swipe left → next
        else setSlide(current - 1); // swipe right → prev
      }
    }, { passive: true });
  }
  // Keyboard arrows (desktop a11y)
  gal.addEventListener('keydown', function(e){
    if (e.key === 'ArrowLeft') { e.preventDefault(); setSlide(current - 1); }
    else if (e.key === 'ArrowRight') { e.preventDefault(); setSlide(current + 1); }
  });
})();

// ════════════════════════════════════════════════════════════════
// Community comments — form "lascia un commento" (blog-style)
// Submit persiste il commento in localStorage, renderizza in moderazione,
// e nasconde il form. Al re-visit il commento dell'utente è ancora lì.
// Tracking: GA4 event 'comment_submitted' (engagement signal alto).
// ════════════════════════════════════════════════════════════════
(function(){
  var form = document.getElementById('hcm-form');
  var formWrap = document.getElementById('hcm-form-wrap');
  var slot = document.getElementById('hcm-user-slot');
  var nameEl = document.getElementById('hcm-c-name');
  var metaEl = document.getElementById('hcm-c-meta');
  var textEl = document.getElementById('hcm-c-text');
  var btn = document.getElementById('hcm-c-submit');
  if (!form || !slot || !btn) return;
  var STORAGE_KEY = 'hl_spray_user_comment_v1';
  var COLORS = ['#6b3a7d','#c0392b','#3d6b4f','#1a56a8','#d4a54a','#92600f','#9b2c2c','#2a5a3a'];
  function escapeHtml(s){
    return String(s||'').replace(/[&<>"']/g, function(c){
      return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];
    });
  }
  function getInitials(name){
    var parts = (name||'').trim().split(/\s+/);
    var i = parts.map(function(s){ return s.charAt(0).toUpperCase(); }).slice(0,2).join('');
    return i || '??';
  }
  function colorFor(name){
    var seed = (name||'').split('').reduce(function(a,c){ return a + c.charCodeAt(0); }, 0);
    return COLORS[Math.abs(seed) % COLORS.length];
  }
  function render(data){
    var initials = getInitials(data.name);
    var color = colorFor(data.name);
    slot.innerHTML =
      '<div class="hcm-c hcm-c--user" data-cid="user" data-author="' + escapeHtml(data.name) + '">' +
        '<div class="hcm-av" style="background:' + color + '">' + escapeHtml(initials) + '</div>' +
        '<div class="hcm-body">' +
          '<span class="hcm-name">' + escapeHtml(data.name) + '</span>' +
          '<span class="hcm-meta">' + escapeHtml(data.meta) + ' · poco fa</span>' +
          '<p class="hcm-text">' + escapeHtml(data.text) + '</p>' +
          '<div class="hcm-likes"><span class="hcm-likes-thumb">⏳</span>In moderazione · verrà pubblicato entro poche ore</div>' +
        '</div>' +
      '</div>';
  }
  // Restore al load se l'utente ha già commentato (localStorage)
  try {
    var stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      var d = JSON.parse(stored);
      if (d && d.name && d.text) {
        render(d);
        if (formWrap) formWrap.style.display = 'none';
      }
    }
  } catch(e) {}
  // Submit handler
  form.addEventListener('submit', function(e){
    e.preventDefault();
    var name = (nameEl.value || '').trim();
    var meta = (metaEl.value || '').trim();
    var text = (textEl.value || '').trim();
    // Validazione semplice
    if (!name || name.length < 2) {
      nameEl.style.borderColor = 'var(--rust)';
      nameEl.focus();
      btn.textContent = 'Inserisci il tuo nome';
      setTimeout(function(){ btn.textContent = 'Pubblica commento'; }, 1800);
      return;
    }
    if (!meta || meta.length < 3) {
      metaEl.style.borderColor = 'var(--rust)';
      metaEl.focus();
      btn.textContent = 'Inserisci età e città';
      setTimeout(function(){ btn.textContent = 'Pubblica commento'; }, 1800);
      return;
    }
    if (!text || text.length < 8) {
      textEl.style.borderColor = 'var(--rust)';
      textEl.focus();
      btn.textContent = 'Scrivi un commento più lungo';
      setTimeout(function(){ btn.textContent = 'Pubblica commento'; }, 1800);
      return;
    }
    btn.disabled = true;
    btn.textContent = 'Invio in corso…';
    var data = { name: name, meta: meta, text: text, ts: Date.now() };
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(data)); } catch(err) {}
    // Tracking
    if (window.gtag) gtag('event', 'comment_submitted', {
      name_length: name.length,
      text_length: text.length,
      page_type: 'spray_offerta'
    });
    if (window.fbq) fbq('trackCustom', 'CommentSubmitted', { page: 'spray_offerta' });
    // Render + nascondi form con un piccolo delay (simula upload)
    setTimeout(function(){
      render(data);
      if (formWrap) formWrap.style.display = 'none';
      try { slot.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch(e) {}
    }, 700);
  });
  // Reset border quando l'utente ricomincia a scrivere
  [nameEl, metaEl, textEl].forEach(function(el){
    if (!el) return;
    el.addEventListener('input', function(){
      el.style.borderColor = '';
    });
  });
})();

// ════════════════════════════════════════════════════════════════
// Community comments — LIKE button (toggle + persist localStorage)
// ════════════════════════════════════════════════════════════════
(function(){
  var LIKES_KEY = 'hl_spray_comment_likes_v1';
  var likedSet = {};
  try {
    var stored = localStorage.getItem(LIKES_KEY);
    if (stored) likedSet = JSON.parse(stored) || {};
  } catch(e) {}
  function saveLikes(){
    try { localStorage.setItem(LIKES_KEY, JSON.stringify(likedSet)); } catch(e) {}
  }
  // Restore state on load: applica .liked class + counter +1 ai commenti già likati
  document.querySelectorAll('.hcm-like-btn').forEach(function(btn){
    var card = btn.closest('.hcm-c');
    if (!card) return;
    var cid = card.getAttribute('data-cid');
    if (cid && likedSet[cid]) {
      btn.classList.add('liked');
      var counter = btn.querySelector('.hcm-like-count');
      if (counter) {
        var n = parseInt(counter.textContent, 10) || 0;
        // Solo se non già incrementato visivamente (cioè se è il primo restore)
        counter.textContent = n + 1;
      }
    }
  });
  // Delegated click handler su tutta la sezione .hcm (catch anche futuri reply)
  var section = document.querySelector('.hcm');
  if (!section) return;
  section.addEventListener('click', function(e){
    var btn = e.target.closest('.hcm-like-btn');
    if (!btn) return;
    var card = btn.closest('.hcm-c');
    if (!card) return;
    var cid = card.getAttribute('data-cid') || ('idx-' + Array.prototype.indexOf.call(card.parentNode.children, card));
    var counter = btn.querySelector('.hcm-like-count');
    if (!counter) return;
    var n = parseInt(counter.textContent, 10) || 0;
    if (likedSet[cid]) {
      // Toggle off
      delete likedSet[cid];
      btn.classList.remove('liked');
      counter.textContent = Math.max(0, n - 1);
    } else {
      // Toggle on
      likedSet[cid] = true;
      btn.classList.add('liked');
      counter.textContent = n + 1;
      if (window.gtag) gtag('event', 'comment_liked', { comment_id: cid, page_type: 'spray_offerta' });
      if (window.fbq) fbq('trackCustom', 'CommentLiked', { comment_id: cid, page: 'spray_offerta' });
    }
    saveLikes();
  });
})();

// ════════════════════════════════════════════════════════════════
// Community comments — REPLY form inline (open/close + submit + persist)
// ════════════════════════════════════════════════════════════════
(function(){
  var REPLIES_KEY = 'hl_spray_comment_replies_v1';
  var COLORS = ['#6b3a7d','#c0392b','#3d6b4f','#1a56a8','#d4a54a','#92600f','#9b2c2c','#2a5a3a'];
  function escapeHtml(s){
    return String(s||'').replace(/[&<>"']/g, function(c){
      return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];
    });
  }
  function getInitials(name){
    var parts = (name||'').trim().split(/\s+/);
    var i = parts.map(function(s){ return s.charAt(0).toUpperCase(); }).slice(0,2).join('');
    return i || '??';
  }
  function colorFor(name){
    var seed = (name||'').split('').reduce(function(a,c){ return a + c.charCodeAt(0); }, 0);
    return COLORS[Math.abs(seed) % COLORS.length];
  }
  // Restore replies from storage
  var replies = [];
  try {
    var stored = localStorage.getItem(REPLIES_KEY);
    if (stored) replies = JSON.parse(stored) || [];
  } catch(e) {}
  function renderReplyCard(r){
    var initials = getInitials(r.name);
    var color = colorFor(r.name);
    var html =
      '<div class="hcm-c hcm-c--reply hcm-c--user-reply" data-cid="reply-' + r.ts + '" data-author="' + escapeHtml(r.name) + '">' +
        '<div class="hcm-av" style="background:' + color + '">' + escapeHtml(initials) + '</div>' +
        '<div class="hcm-body">' +
          '<span class="hcm-name">' + escapeHtml(r.name) + '</span>' +
          '<span class="hcm-meta">' + escapeHtml(r.meta) + ' · poco fa</span>' +
          '<p class="hcm-text">' + escapeHtml(r.text) + '</p>' +
          '<div class="hcm-likes"><span class="hcm-likes-thumb" style="background:#d4a54a">⏳</span><span style="color:#92600f;font-weight:600">In moderazione</span></div>' +
        '</div>' +
      '</div>';
    return html;
  }
  // Inserisci risposte salvate dopo il commento parent (al load)
  replies.forEach(function(r){
    var parent = document.querySelector('.hcm-c[data-cid="' + r.parent + '"]');
    if (!parent) return;
    parent.insertAdjacentHTML('afterend', renderReplyCard(r));
  });
  function saveReplies(){
    try { localStorage.setItem(REPLIES_KEY, JSON.stringify(replies)); } catch(e) {}
  }
  // Delegated click su sezione .hcm — gestisce "Rispondi" + cancel + submit
  var section = document.querySelector('.hcm');
  if (!section) return;
  section.addEventListener('click', function(e){
    // Bottone Rispondi → apre form inline sotto il commento
    var replyBtn = e.target.closest('.hcm-likes-reply');
    if (replyBtn) {
      var card = replyBtn.closest('.hcm-c');
      if (!card) return;
      // Toggle: se esiste già un form aperto sotto, chiudilo
      var existing = card.querySelector(':scope > .hcm-body > .hcm-reply-form');
      if (existing) {
        existing.classList.remove('show');
        replyBtn.classList.remove('active');
        setTimeout(function(){ if (existing.parentNode) existing.parentNode.removeChild(existing); }, 200);
        return;
      }
      // Chiudi altri form aperti
      document.querySelectorAll('.hcm-reply-form.show').forEach(function(f){
        f.classList.remove('show');
        setTimeout(function(){ if (f.parentNode) f.parentNode.removeChild(f); }, 200);
      });
      document.querySelectorAll('.hcm-likes-reply.active').forEach(function(b){ b.classList.remove('active'); });
      // Crea nuovo form
      var author = card.getAttribute('data-author') || 'questo commento';
      var formHtml =
        '<div class="hcm-reply-form show">' +
          '<form class="hcm-reply-form-inner" novalidate>' +
            '<div class="hcm-reply-form-row">' +
              '<input type="text" class="hcm-reply-input hcm-r-name" placeholder="Il tuo nome" maxlength="40" required aria-label="Nome">' +
              '<input type="text" class="hcm-reply-input hcm-r-meta" placeholder="Età e città" maxlength="50" required aria-label="Età e città">' +
            '</div>' +
            '<textarea class="hcm-reply-input hcm-r-text" placeholder="Rispondi a ' + escapeHtml(author) + '…" maxlength="500" required aria-label="Risposta"></textarea>' +
            '<div class="hcm-reply-actions">' +
              '<button type="submit" class="hcm-reply-submit">Pubblica risposta</button>' +
              '<button type="button" class="hcm-reply-cancel">Annulla</button>' +
            '</div>' +
          '</form>' +
        '</div>';
      var body = card.querySelector(':scope > .hcm-body');
      if (body) {
        body.insertAdjacentHTML('beforeend', formHtml);
        replyBtn.classList.add('active');
        // Focus sul nome (utente ha esplicitamente cliccato Rispondi → keyboard OK)
        var nameInput = card.querySelector('.hcm-r-name');
        if (nameInput) {
          try { nameInput.focus({ preventScroll: false }); } catch(err) { try { nameInput.focus(); } catch(e2) {} }
        }
      }
      return;
    }
    // Annulla → chiudi form
    if (e.target.classList && e.target.classList.contains('hcm-reply-cancel')) {
      var form = e.target.closest('.hcm-reply-form');
      var parentCard = e.target.closest('.hcm-c');
      if (form) {
        form.classList.remove('show');
        if (parentCard) {
          var btn = parentCard.querySelector(':scope > .hcm-body > .hcm-likes > .hcm-likes-reply');
          if (btn) btn.classList.remove('active');
        }
        setTimeout(function(){ if (form.parentNode) form.parentNode.removeChild(form); }, 200);
      }
      return;
    }
  });
  // Delegated submit
  section.addEventListener('submit', function(e){
    if (!e.target.classList.contains('hcm-reply-form-inner')) return;
    e.preventDefault();
    var form = e.target;
    var card = form.closest('.hcm-c');
    if (!card) return;
    var nameInput = form.querySelector('.hcm-r-name');
    var metaInput = form.querySelector('.hcm-r-meta');
    var textInput = form.querySelector('.hcm-r-text');
    var submitBtn = form.querySelector('.hcm-reply-submit');
    var name = (nameInput.value || '').trim();
    var meta = (metaInput.value || '').trim();
    var text = (textInput.value || '').trim();
    var bad = null;
    if (!name || name.length < 2) bad = nameInput;
    else if (!meta || meta.length < 3) bad = metaInput;
    else if (!text || text.length < 5) bad = textInput;
    if (bad) {
      bad.style.borderColor = 'var(--rust)';
      bad.focus();
      submitBtn.textContent = 'Compila tutti i campi';
      setTimeout(function(){ submitBtn.textContent = 'Pubblica risposta'; }, 1600);
      return;
    }
    submitBtn.disabled = true;
    submitBtn.textContent = 'Invio…';
    var parentCid = card.getAttribute('data-cid') || 'unknown';
    var reply = { parent: parentCid, name: name, meta: meta, text: text, ts: Date.now() };
    replies.push(reply);
    saveReplies();
    if (window.gtag) gtag('event', 'comment_replied', { parent_cid: parentCid, text_length: text.length, page_type: 'spray_offerta' });
    if (window.fbq) fbq('trackCustom', 'CommentReplied', { parent_cid: parentCid, page: 'spray_offerta' });
    setTimeout(function(){
      // Inserisci la nuova risposta dopo il parent + rimuovi il form
      card.insertAdjacentHTML('afterend', renderReplyCard(reply));
      var formWrap = form.closest('.hcm-reply-form');
      if (formWrap) {
        formWrap.classList.remove('show');
        var replyBtnActive = card.querySelector(':scope > .hcm-body > .hcm-likes > .hcm-likes-reply');
        if (replyBtnActive) replyBtnActive.classList.remove('active');
        setTimeout(function(){ if (formWrap.parentNode) formWrap.parentNode.removeChild(formWrap); }, 200);
      }
    }, 600);
  });
  // Reset border quando l'utente digita
  section.addEventListener('input', function(e){
    if (e.target.classList && e.target.classList.contains('hcm-reply-input')) {
      e.target.style.borderColor = '';
    }
  });
})();

// ════════════════════════════════════════════════════════════════
// POPUP full-screen — 4 stage: question → capture → success → expired
// + Manual trigger via .discount-chip
// + Sticky discount bar (sopra la sticky ATC) con countdown live
// ════════════════════════════════════════════════════════════════
(function(){
  var POPUP_KEY = 'hl_spray_popup_shown_v1';
  var POPUP_DECLINED_KEY = 'hl_spray_popup_declined_v1';
  var EMAIL_KEY = 'hl_quiz_email';
  var DISCOUNT_KEY = window.hlSprayDiscount.KEY;
  var DISCOUNT_TS_KEY = window.hlSprayDiscount.TS_KEY;
  var DURATION_MS = window.hlSprayDiscount.DURATION_MS;
  var DISCOUNT_CODE = window.hlSprayDiscount.CODE;

  var popup = document.getElementById('popup');
  if (!popup) return;
  var question = document.getElementById('popup-question');
  var capture = document.getElementById('popup-capture');
  var success = document.getElementById('popup-success');
  var expired = document.getElementById('popup-expired');
  var form = document.getElementById('popup-form');
  var emailInput = document.getElementById('popup-email');
  var submitBtn = document.getElementById('popup-submit');
  var countdownEl = document.getElementById('popup-countdown');
  var stickyEl = document.getElementById('sticky');
  var stickyCd = document.getElementById('sticky-cd');
  var stickyDiscountLabel = document.getElementById('sticky-discount-label');
  var chip = document.getElementById('discount-chip');

  // State
  var triggered = false;
  var unlockTs = 0;
  var countdownInterval = null;

  function readState(){
    var s = { shown: false, declined: false, unlocked: false, hasEmail: false };
    try {
      s.shown = !!localStorage.getItem(POPUP_KEY);
      s.declined = !!localStorage.getItem(POPUP_DECLINED_KEY);
      s.hasEmail = !!localStorage.getItem(EMAIL_KEY);
      s.unlocked = window.hlSprayDiscount.isActive();
    } catch(e) {}
    return s;
  }

  // Apply discount to all cart links + show sticky bar + update sticky price
  function applyDiscount() {
    var links = document.querySelectorAll('a[href*="hairletics.com/cart/"]');
    links.forEach(function(link){
      try {
        var url = new URL(link.href);
        if (!url.searchParams.has('discount')) {
          url.searchParams.set('discount', DISCOUNT_CODE);
          link.href = url.toString();
        }
      } catch(e) {}
    });
    showStickyDiscountBar();
    if (window.hlUpdateSelectedSticky) window.hlUpdateSelectedSticky();
  }

  function stripDiscount() {
    var links = document.querySelectorAll('a[href*="hairletics.com/cart/"]');
    links.forEach(function(link){
      try {
        var url = new URL(link.href);
        if (url.searchParams.get('discount') === DISCOUNT_CODE) {
          url.searchParams.delete('discount');
          link.href = url.toString();
        }
      } catch(e) {}
    });
  }

  function showStickyDiscountBar(){
    if (stickyEl) {
      stickyEl.classList.add('has-discount');
      stickyEl.classList.remove('expired');
      if (stickyDiscountLabel) stickyDiscountLabel.textContent = 'Sconto attivo';
    }
  }
  function hideStickyDiscountBar(){
    if (stickyEl) {
      stickyEl.classList.remove('has-discount');
      stickyEl.classList.remove('expired');
    }
  }

  // Scroll lock — iOS-safe via position:fixed + memorizza scrollY (vs naive overflow:hidden)
  var _lockedScrollY = 0;
  function lockBodyScroll(){
    if (document.body.classList.contains('popup-locked')) return;
    _lockedScrollY = window.scrollY || window.pageYOffset || 0;
    document.body.style.setProperty('--popup-lock-y', '-' + _lockedScrollY + 'px');
    document.body.classList.add('popup-locked');
  }
  function unlockBodyScroll(){
    if (!document.body.classList.contains('popup-locked')) return;
    document.body.classList.remove('popup-locked');
    document.body.style.removeProperty('--popup-lock-y');
    window.scrollTo(0, _lockedScrollY);
  }

  // Re-trigger CSS animazione su un elemento (rimuove + re-applica la classe via reflow)
  function retriggerStageAnim(el){
    if (!el || el.hidden) return;
    el.style.animation = 'none';
    // Force reflow
    void el.offsetWidth;
    el.style.animation = '';
  }

  function show(stage){
    var firstOpen = !popup.classList.contains('show');
    popup.classList.add('show');
    popup.removeAttribute('inert');
    popup.setAttribute('aria-hidden', 'false');
    question.hidden = stage !== 'question';
    capture.hidden = stage !== 'capture';
    success.hidden = stage !== 'success';
    expired.hidden = stage !== 'expired';
    lockBodyScroll();
    // Re-trigger animazione sulla nuova stage visibile (solo se non è la prima apertura,
    // perché la prima apertura già anima via .popup-box transition)
    if (!firstOpen) {
      var visibleStage = (stage === 'question' ? question
        : stage === 'capture' ? capture
        : stage === 'success' ? success
        : stage === 'expired' ? expired : null);
      retriggerStageAnim(visibleStage);
    }
  }
  function close(){
    popup.classList.remove('show');
    popup.setAttribute('aria-hidden', 'true');
    popup.setAttribute('inert', '');
    unlockBodyScroll();
  }

  function trigger(reason) {
    if (triggered) return;
    triggered = true;
    show('question');
    try { localStorage.setItem(POPUP_KEY, '1'); } catch(e) {}
    if (window.gtag) gtag('event', 'popup_shown', { trigger: reason, page_type: 'spray_offerta' });
    if (window.fbq) fbq('trackCustom', 'PopupShown', { trigger: reason, page: 'spray_offerta' });
  }

  function startCountdown(){
    if (!unlockTs) unlockTs = window.hlSprayDiscount.unlockTs() || Date.now();
    if (countdownInterval) clearInterval(countdownInterval);
    function tick(){
      var remaining = DURATION_MS - (Date.now() - unlockTs);
      if (remaining <= 0) {
        clearInterval(countdownInterval);
        try {
          localStorage.removeItem(DISCOUNT_KEY);
          localStorage.removeItem(DISCOUNT_TS_KEY);
        } catch(e) {}
        stripDiscount();
        // Sticky bar: flash 'expired' style for 3s, poi nascondi
        if (stickyEl && stickyEl.classList.contains('has-discount')) {
          stickyEl.classList.add('expired');
          if (stickyDiscountLabel) stickyDiscountLabel.textContent = 'Sconto scaduto';
          if (stickyCd) stickyCd.textContent = '0:00';
          setTimeout(function(){
            hideStickyDiscountBar();
            if (stickyDiscountLabel) stickyDiscountLabel.textContent = 'Sconto attivo';
          }, 3000);
        }
        // Revert sticky price
        if (window.hlUpdateSelectedSticky) window.hlUpdateSelectedSticky();
        // Show expired in popup if currently visible
        if (popup.classList.contains('show')) show('expired');
        return;
      }
      var min = Math.floor(remaining / 60000);
      var sec = Math.floor((remaining % 60000) / 1000);
      var timeStr = min + ':' + (sec < 10 ? '0' + sec : sec);
      if (countdownEl) countdownEl.innerHTML = 'Valido per: <b>' + timeStr + '</b>';
      if (stickyCd) stickyCd.textContent = timeStr;
    }
    tick();
    countdownInterval = setInterval(tick, 1000);
  }

  function finishCapture(email){
    try {
      localStorage.setItem(EMAIL_KEY, email);
      localStorage.setItem(DISCOUNT_KEY, '1');
      localStorage.setItem(DISCOUNT_TS_KEY, Date.now().toString());
    } catch(e) {}
    unlockTs = Date.now();
    if (window.gtag) gtag('event', 'popup_email_capture', { page_type: 'spray_offerta' });
    // Meta Lead — browser pixel + CAPI server-side (dedup via event_id condiviso)
    var leadEventId = (window.crypto && crypto.randomUUID)
      ? crypto.randomUUID()
      : 'lead-' + Date.now() + '-' + Math.random().toString(36).slice(2,10);
    var leadData = {
      content_name: 'Spray Discount Popup',
      content_category: 'Email Capture',
      lead_type: 'Spray Landing Popup',
      value: 1,
      currency: 'EUR'
    };
    if (window.fbq) {
      fbq('trackCustom', 'PopupEmailCapture', { page: 'spray_offerta' });
      fbq('track', 'Lead', leadData, { eventID: leadEventId });
    }
    // CAPI fire-and-forget (keepalive sopravvive a navigate)
    try {
      fetch('https://salute.hairletics.com/api/meta-capi', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(Object.assign({
          event_name: 'Lead',
          email: email,
          event_id: leadEventId,
          event_source_url: location.href,
          custom_data: leadData
        }, _hlFbc())),
        keepalive: true
      }).catch(function(){});
    } catch(e) {}
    applyDiscount();
    show('success');
    startCountdown();
    // Auto-close popup dopo 4.5s — user ha visto conferma, ora deve restare sulla landing
    setTimeout(function(){
      if (popup.classList.contains('show') && !success.hidden) close();
    }, 4500);
  }

  // ──── INIT — restore state if discount already unlocked from previous session ────
  var state = readState();
  if (state.unlocked) {
    unlockTs = window.hlSprayDiscount.unlockTs();
    applyDiscount();
    startCountdown();
  }

  // ──── Bind TUTTI i handler — SEMPRE, indipendentemente dallo stato localStorage ────
  // (FIX: prima i handler erano dopo l'early return, quindi al re-visit non si bindavano
  //  e il form submit faceva default reload pagina → popup sparisce, bar non appare)

  // Chip "Prendi sconto" inline
  if (chip) {
    chip.addEventListener('click', function(){
      if (window.gtag) gtag('event', 'discount_chip_clicked', { page_type: 'spray_offerta' });
      if (window.fbq) fbq('trackCustom', 'DiscountChipClicked', { page: 'spray_offerta' });
      if (window.hlSprayDiscount.isActive()) {
        unlockTs = window.hlSprayDiscount.unlockTs();
        show('success');
        startCountdown();
      } else {
        try {
          localStorage.removeItem(POPUP_KEY);
          localStorage.removeItem(POPUP_DECLINED_KEY);
        } catch(e) {}
        triggered = false;
        trigger('manual_chip');
      }
    });
  }

  // Stage handlers
  document.getElementById('popup-yes').addEventListener('click', function(){
    show('capture');
    if (window.gtag) gtag('event', 'popup_yes_clicked', { page_type: 'spray_offerta' });
    if (window.fbq) fbq('trackCustom', 'PopupYesClicked', { page: 'spray_offerta' });
    // No auto-focus su email input (preference Andrea: no tastiera mobile forzata).
    // L'utente clicca consapevolmente sul campo quando vuole digitare.
  });

  document.getElementById('popup-no').addEventListener('click', function(){
    try { localStorage.setItem(POPUP_DECLINED_KEY, '1'); } catch(e) {}
    if (window.gtag) gtag('event', 'popup_no_clicked', { page_type: 'spray_offerta' });
    if (window.fbq) fbq('trackCustom', 'PopupNoClicked', { page: 'spray_offerta' });
    close();
  });

  document.getElementById('popup-back').addEventListener('click', function(){ show('question'); });

  document.getElementById('popup-close').addEventListener('click', function(){
    try { localStorage.setItem(POPUP_DECLINED_KEY, '1'); } catch(e) {}
    if (window.gtag) gtag('event', 'popup_x_closed', { page_type: 'spray_offerta' });
    close();
  });
  document.getElementById('popup-continue').addEventListener('click', close);
  document.getElementById('popup-close-expired').addEventListener('click', close);
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && popup.classList.contains('show')) close(); });

  // Track quando user inizia a digitare email (proxy per "form_start")
  var _formStartFired = false;
  emailInput.addEventListener('input', function(){
    if (_formStartFired) return;
    _formStartFired = true;
    if (window.gtag) gtag('event', 'popup_form_start', { page_type: 'spray_offerta' });
    if (window.fbq) fbq('trackCustom', 'PopupFormStart', { page: 'spray_offerta' });
  });
  // Track validation fail (per capire se la gente prova ma viene rifiutata)
  // Form submit — FIX: ora sempre bound, anche al re-visit
  form.addEventListener('submit', function(e){
    e.preventDefault();
    var email = (emailInput.value || '').trim().toLowerCase();
    if (!email || email.indexOf('@') < 1 || email.length > 254) {
      emailInput.style.borderColor = 'var(--rust)';
      emailInput.focus();
      if (window.gtag) gtag('event', 'popup_validation_fail', { page_type: 'spray_offerta', reason: !email ? 'empty' : 'no_at' });
      return;
    }
    submitBtn.disabled = true;
    submitBtn.textContent = 'Invio in corso...';

    // Klaviyo client-side API (same pattern as /inizia/ + /quiz/) — no backend needed
    var KLAVIYO_SITE_ID = 'Xeqv6B';
    var EMAIL_LIST_ID = 'WhtF8L'; // "Email List"
    var props = {
      'Source': 'spray_landing_popup',
      'Discount Code': 'GRAZIA20',
      'Spray_Popup_At': new Date().toISOString()
    };
    try {
      // 1. Subscribe to list (consent SUBSCRIBED via custom_source)
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO_SITE_ID, {
        method: 'POST',
        headers: { 'revision': '2024-10-15', 'content-type': 'application/json' },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              profile: { data: { type: 'profile', attributes: { email: email, properties: props } } },
              custom_source: 'Spray Landing Popup'
            },
            relationships: { list: { data: { type: 'list', id: EMAIL_LIST_ID } } }
          }
        }),
        keepalive: true
      });
      // 2. Fire metric event 'Spray_Discount_Unlocked' (triggers the flow)
      fetch('https://a.klaviyo.com/client/events/?company_id=' + KLAVIYO_SITE_ID, {
        method: 'POST',
        headers: { 'revision': '2024-10-15', 'content-type': 'application/json' },
        body: JSON.stringify({
          data: {
            type: 'event',
            attributes: {
              properties: props,
              metric: { data: { type: 'metric', attributes: { name: 'Spray_Discount_Unlocked' } } },
              profile: { data: { type: 'profile', attributes: { email: email } } }
            }
          }
        }),
        keepalive: true
      });
    } catch (err) { console.warn('Klaviyo error:', err); }

    // Fire-and-forget — don't block UX waiting for Klaviyo response
    finishCapture(email);
  });

  // Skip AUTO-trigger (mouseout/scroll/35s) if user already engaged or unlocked
  // Ma chip + handlers sono già stati bound sopra, quindi click chip continua a funzionare
  if (state.unlocked || state.shown || state.declined || state.hasEmail) return;

  // ──── AUTO-TRIGGERS (only if first visit, no email, no decline) ────
  // Best practice da "Billion Dollar Websites" (Dylan Ander, $5B+ optimized):
  //   - 8 sec è "the magic number" testato su 100+ siti
  //   - Exit-intent + scroll 50% combo = Perfect Popup trigger
  // 1. Exit intent (desktop)
  document.addEventListener('mouseout', function(e){
    if (triggered) return;
    if (!e.relatedTarget && e.clientY < 5) trigger('exit_intent');
  });

  // 2. Scroll past 50% (era 60% — più aggressivo come da Dylan Ander)
  var scrollHandler = function(){
    if (triggered) return;
    var max = document.documentElement.scrollHeight - window.innerHeight;
    if (max <= 0) return;
    if (window.scrollY / max >= 0.5) {
      trigger('scroll_50');
      window.removeEventListener('scroll', scrollHandler);
    }
  };
  window.addEventListener('scroll', scrollHandler, { passive: true });

  // 3. 8s fallback (era 35s — Dylan testato magic number = 8s su 100+ siti)
  setTimeout(function(){ if (!triggered) trigger('time_8s'); }, 8000);
})();

// Urgency stock — slow decrement (persistent via localStorage), bottoms at 47
// Sync con #tb-stock (top urgency bar) e #urg-stock (urgency block)
(function(){
  var el = document.getElementById('urg-stock');
  var elTop = document.getElementById('tb-stock');
  if(!el && !elTop) return;
  var KEY = 'hl_spray_stock_v1';
  var TS_KEY = 'hl_spray_stock_ts_v1';
  var LOT_SIZE = 500; // dimensione totale del lotto (per calcolo % esaurito)
  var INITIAL = 423;  // stock visibile al primo load (= 15% già esaurito su 500)
  var FLOOR = 47;
  var stock = INITIAL;
  try {
    var stored = localStorage.getItem(KEY);
    var storedTs = localStorage.getItem(TS_KEY);
    if(stored && storedTs){
      stock = parseInt(stored, 10);
      var hoursPassed = (Date.now() - parseInt(storedTs, 10)) / 3600000;
      var sold = Math.floor(hoursPassed / 3); // ~1 sale every 3h
      stock = Math.max(FLOOR, stock - sold);
    }
  } catch(e) {}
  var elTopProm = document.getElementById('urg-stock-top');
  var elPctProm = document.getElementById('urg-pct-top');
  var elFillProm = document.getElementById('urg-fill-top');
  function renderStock(){
    if(el) el.textContent = stock;
    if(elTop) elTop.textContent = stock;
    if(elTopProm) elTopProm.textContent = stock;
    var pct = Math.round(((LOT_SIZE - stock) / LOT_SIZE) * 100);
    if(elPctProm) elPctProm.textContent = pct + '% esaurito';
    if(elFillProm) elFillProm.style.width = pct + '%';
  }
  renderStock();
  try {
    localStorage.setItem(KEY, stock.toString());
    localStorage.setItem(TS_KEY, Date.now().toString());
  } catch(e) {}
  // Slow live decrement
  setInterval(function(){
    if(Math.random() < 0.12 && stock > FLOOR){
      stock--;
      renderStock();
      try {
        localStorage.setItem(KEY, stock.toString());
        localStorage.setItem(TS_KEY, Date.now().toString());
      } catch(e) {}
    }
  }, 90000);
})();

// TOP urgency countdown — 48h personal deadline, persistente in localStorage
(function(){
  var el = document.getElementById('tb-cd');
  if(!el) return;
  var DEADLINE_KEY = 'hl_spray_deadline_v1';
  var WINDOW_MS = 48 * 60 * 60 * 1000; // 48h
  var deadlineTs;
  try {
    var stored = localStorage.getItem(DEADLINE_KEY);
    if(stored){
      deadlineTs = parseInt(stored, 10);
      if(Date.now() > deadlineTs){
        // Già scaduto — rinnova per altri 48h (non vogliamo barra rotta)
        deadlineTs = Date.now() + WINDOW_MS;
        localStorage.setItem(DEADLINE_KEY, deadlineTs.toString());
      }
    } else {
      deadlineTs = Date.now() + WINDOW_MS;
      localStorage.setItem(DEADLINE_KEY, deadlineTs.toString());
    }
  } catch(e){ deadlineTs = Date.now() + WINDOW_MS; }
  function tick(){
    var remaining = deadlineTs - Date.now();
    if(remaining <= 0){ remaining = 0; }
    var h = Math.floor(remaining / 3600000);
    var m = Math.floor((remaining % 3600000) / 60000);
    var s = Math.floor((remaining % 60000) / 1000);
    var pad = function(n){ return n < 10 ? '0' + n : '' + n; };
    el.textContent = pad(h) + ':' + pad(m) + ':' + pad(s);
  }
  tick();
  setInterval(tick, 1000);
})();


// ═══════════════════════════════════════════════════════════════


(function(){
  function startDeferred(){
    // Carica gtag.js + fbevents.js DOPO LCP (libera ~500ms thread durante critical render)
    if(window._hlLoadGtag)try{_hlLoadGtag();}catch(e){}
    if(window._hlLoadFbPixel)try{_hlLoadFbPixel();}catch(e){}
    // Fire browser-side Pixel events (queue-based, completa quando fbevents.js arriva)
    if(window._hlFireBrowserPixel)try{_hlFireBrowserPixel();}catch(e){}
    // Track A/B headline variant assignment (gtag + fbq queue-based)
    if(window._hlH1TrackVariant)try{_hlH1TrackVariant();}catch(e){}
    // CAPI server-side fired molto più tardi (5s) — keepalive la rende safe da page navigate
    setTimeout(function(){if(window._hlFireServerCapi)try{_hlFireServerCapi();}catch(e){}},5000);
    // _fbp cross-domain promote (runs at 800ms + 2500ms)
    function _hlPromoteFbp(){try{var m=document.cookie.match(/(?:^|; )_fbp=([^;]*)/);if(m){document.cookie='_fbp='+decodeURIComponent(m[1])+'; path=/; domain=.hairletics.com; max-age='+(90*86400)+'; SameSite=Lax'+(location.protocol==='https:'?'; Secure':'');}}catch(e){}}
    setTimeout(_hlPromoteFbp,800);setTimeout(_hlPromoteFbp,2500);

    // Scroll depth (25/50/75/90%)
    var fired={};var thresholds=[25,50,75,90];
    window.addEventListener('scroll',function(){
      var pct=Math.round(window.scrollY/(document.documentElement.scrollHeight-window.innerHeight)*100);
      for(var i=0;i<thresholds.length;i++){var t=thresholds[i];if(pct>=t&&!fired[t]){fired[t]=true;if(window.fbq)fbq('trackCustom','ScrollDepth',{depth:t+'%',page:'spray_offerta'});if(window.gtag)gtag('event','scroll_depth',{depth:t,page_type:'spray_offerta'});}}
    },{passive:true});

    // CTA click delegation (cart links)
    document.addEventListener('click',function(e){
      var link=e.target.closest('a[href*="hairletics.com/cart/"]');
      if(!link||!window.gtag)return;
      var href=link.href;var bundleName='unknown';var bundleValue=0;
      if(href.indexOf('55744823984468')>-1){bundleName='provalo';bundleValue=24.5;}
      else if(href.indexOf('55744832373076')>-1){bundleName='protocollo';bundleValue=49;}
      else if(href.indexOf('55744839090516')>-1){bundleName='mantenimento';bundleValue=73.5;}
      gtag('event','cta_click',{bundle:bundleName,value:bundleValue,page_type:'spray_offerta'});
    });

    // time_on_page checkpoints
    var checkpoints=[15,30,60,120,240,480];
    checkpoints.forEach(function(s){setTimeout(function(){if(window.gtag)gtag('event','time_on_page',{seconds:s,page_type:'spray_offerta'});if(window.fbq)fbq('trackCustom','TimeOnPage',{seconds:s,page:'spray_offerta'});},s*1000);});

    // engagement heartbeat (active seconds)
    var t=0;setInterval(function(){if(document.visibilityState!=='visible')return;t+=30;if(window.gtag)gtag('event','engagement_ping',{active_seconds:t,page_type:'spray_offerta'});},30000);

    // Clarity — defer 3 sec (heatmap, non blocca LCP)
    setTimeout(function(){
      (function(c,l,a,r,i,t,y){c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);})(window,document,"clarity","script","wdck5hq2py");
    },3000);

    // ─── Grazia AI chat — deferred init (no LCP impact) ───
    initGraziaChat();
  }

  function initGraziaChat(){
    var btn = document.getElementById('gz-chat-btn');
    var panel = document.getElementById('gz-chat-panel');
    var closeBtn = document.getElementById('gz-chat-close');
    var bodyEl = document.getElementById('gz-chat-body');
    var textarea = document.getElementById('gz-chat-textarea');
    var sendBtn = document.getElementById('gz-chat-send');
    var errorEl = document.getElementById('gz-chat-error');
    var pulseEl = document.getElementById('gz-chat-pulse');
    var notifEl = document.getElementById('gz-chat-notif');
    var bubbleEl = document.getElementById('gz-chat-bubble');
    var bubbleClose = document.getElementById('gz-chat-bubble-close');
    if(!btn || !panel) return;

    var STORAGE_KEY = 'hl_gz_spray_history';
    var STATE_KEY = 'hl_gz_spray_state';
    var SESSION_KEY = 'hl_gz_spray_session';
    var MAX_TURNS = 30;

    function getSessionId(){
      try{
        var sid = sessionStorage.getItem(SESSION_KEY);
        if(!sid){ sid = 'gz-spray-'+Date.now()+'-'+Math.random().toString(36).slice(2,10); sessionStorage.setItem(SESSION_KEY, sid); }
        return sid;
      }catch(e){ return 'gz-spray-'+Date.now(); }
    }
    function loadHistory(){ try{ var h=localStorage.getItem(STORAGE_KEY); if(h) return JSON.parse(h); }catch(e){} return []; }
    function saveHistory(h){ try{ localStorage.setItem(STORAGE_KEY, JSON.stringify(h.slice(-MAX_TURNS))); }catch(e){} }
    function loadState(){ try{ var s=localStorage.getItem(STATE_KEY); if(s) return JSON.parse(s); }catch(e){} return {opened:false,dismissed:false}; }
    function saveState(s){ try{ localStorage.setItem(STATE_KEY, JSON.stringify(s)); }catch(e){} }

    var history = loadHistory();
    var state = loadState();
    var sessionId = getSessionId();
    var sending = false;

    function escapeHtml(s){ return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }
    function renderMarkdown(s){
      var html = escapeHtml(s);
      html = html.replace(/\[([^\]]+)\]\(([^)]+)\)/g, function(_, txt, url){
        var safe = url.replace(/[<>"'\s]/g,'');
        if(!/^(https?:|mailto:|\/)/.test(safe)) return txt;
        return '<a href="'+safe+'" target="_blank" rel="noopener">'+txt+'</a>';
      });
      html = html.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>');
      html = html.replace(/\n/g, '<br>');
      return html;
    }
    function addMessageDom(role, content){
      var d = document.createElement('div');
      d.className = 'gz-msg gz-msg-' + (role === 'assistant' ? 'grazia' : 'user');
      d.innerHTML = renderMarkdown(content);
      bodyEl.appendChild(d);
      scrollToBottom();
    }
    function showTyping(){
      var d = document.createElement('div');
      d.className = 'gz-msg-typing'; d.id = 'gz-typing';
      d.innerHTML = '<span></span><span></span><span></span>';
      bodyEl.appendChild(d);
      scrollToBottom();
    }
    function hideTyping(){ var t=document.getElementById('gz-typing'); if(t) t.remove(); }
    function showError(msg){
      errorEl.textContent = msg;
      errorEl.style.display = 'block';
      setTimeout(function(){ errorEl.style.display = 'none'; }, 6000);
    }
    function scrollToBottom(){ setTimeout(function(){ bodyEl.scrollTop = bodyEl.scrollHeight; }, 50); }

    // Cold impulse opener — niente quiz reference, generic warm
    function buildGreeting(){
      return 'Ciao, sono Grazia. **Tricologa Hairletics**.\n\nVedo che stai guardando il Protocollo. Cosa ti frena di più — il prezzo, la paura che non funzioni, o qualcos\'altro?';
    }

    function openPanel(){
      panel.classList.add('show');
      panel.removeAttribute('inert');
      bubbleEl.classList.remove('show');
      notifEl.classList.remove('show');
      pulseEl.classList.remove('active');
      state.opened = true;
      saveState(state);
      if(history.length === 0){
        var greet = buildGreeting();
        history.push({role:'assistant', content: greet});
        saveHistory(history);
        addMessageDom('assistant', greet);
      } else {
        bodyEl.innerHTML = '';
        history.forEach(function(m){ addMessageDom(m.role, m.content); });
      }
      setTimeout(function(){ if(window.innerWidth > 520) textarea.focus(); }, 250);
      try{ if(window.gtag)gtag('event','chat_grazia_opened',{page_type:'spray_offerta'}); if(window.fbq)fbq('trackCustom','GraziaChatOpened',{page:'spray_offerta'}); }catch(e){}
    }
    function closePanel(){ panel.classList.remove('show'); panel.setAttribute('inert',''); }

    async function sendMessage(text){
      if(sending) return;
      text = (text||'').trim();
      if(!text) return;
      if(history.length >= MAX_TURNS){
        showError('Limite conversazione raggiunto. Scrivi a support@hairletics.com per continuare.');
        return;
      }
      sending = true;
      sendBtn.disabled = true;
      var userMsg = { role:'user', content: text };
      history.push(userMsg);
      addMessageDom('user', text);
      saveHistory(history);
      textarea.value = '';
      textarea.style.height = '40px';
      showTyping();
      try{
        var resp = await fetch('https://salute.hairletics.com/api/chat', {
          method:'POST',
          headers:{'Content-Type':'application/json'},
          body: JSON.stringify({
            messages: history.slice(-12),
            landing: 'spray-impulse',
            session_id: sessionId
          })
        });
        var data = await resp.json();
        hideTyping();
        if(!resp.ok){
          showError(data.error || 'Errore. Riprova tra qualche secondo.');
        } else {
          var reply = data.reply || '';
          history.push({role:'assistant', content: reply});
          saveHistory(history);
          addMessageDom('assistant', reply);
          try{ if(window.gtag)gtag('event','chat_grazia_message',{ count: history.length, page_type:'spray_offerta' }); if(window.fbq)fbq('trackCustom','GraziaChatMessage',{ count: history.length, page:'spray_offerta' }); }catch(e){}
        }
      } catch(e) {
        hideTyping();
        showError('Errore di connessione. Riprova.');
      } finally {
        sending = false;
        sendBtn.disabled = false;
      }
    }

    textarea.addEventListener('input', function(){
      textarea.style.height = '40px';
      textarea.style.height = Math.min(textarea.scrollHeight, 96) + 'px';
    });
    textarea.addEventListener('keydown', function(e){
      if(e.key === 'Enter' && !e.shiftKey){ e.preventDefault(); sendMessage(textarea.value); }
    });
    sendBtn.addEventListener('click', function(){ sendMessage(textarea.value); });
    btn.addEventListener('click', openPanel);
    closeBtn.addEventListener('click', closePanel);
    bubbleClose.addEventListener('click', function(e){
      e.stopPropagation();
      bubbleEl.classList.remove('show');
      state.dismissed = true;
      saveState(state);
    });
    bubbleEl.addEventListener('click', function(e){
      if(e.target.id === 'gz-chat-bubble-close') return;
      openPanel();
    });
    document.addEventListener('keydown', function(e){
      if(e.key === 'Escape' && panel.classList.contains('show')) closePanel();
    });

    // Auto behaviors — più gentili del /piano/ per cold impulse:
    // Pulse a 25 sec idle, bubble a 35 sec idle (non 15/25 come piano)
    setTimeout(function(){
      if(!state.opened && !state.dismissed && history.length === 0){
        pulseEl.classList.add('active');
        notifEl.classList.add('show');
      }
    }, 25000);
    setTimeout(function(){
      if(!state.opened && !state.dismissed && history.length === 0){
        bubbleEl.classList.add('show');
      }
    }, 35000);
  }
  // Run after page is interactive — non blocca LCP/FCP
  if(window.requestIdleCallback){requestIdleCallback(startDeferred,{timeout:2500});}
  else if(document.readyState==='complete'){setTimeout(startDeferred,1);}
  else {window.addEventListener('load',function(){setTimeout(startDeferred,1);});}
})();
